import { ListBase, useListContext } from "ra-core";
import { Link } from "react-router";

function Rows() {
  const { data, isPending, error } = useListContext();

  if (isPending) return <div className="p-4 text-sm text-muted-foreground">Loading estimates…</div>;
  if (error) return <div className="p-4 text-sm text-destructive">Failed to load estimates.</div>;
  if (!data || data.length === 0) return <div className="p-4 text-sm text-muted-foreground">No estimates yet.</div>;

  return (
    <div className="divide-y">
      {data.map((rec: any) => (
        <Link
          key={rec.id}
          to={`/estimates/${rec.id}/show`}
          className="block p-4 hover:bg-muted/40 transition"
        >
          <div className="flex items-center justify-between gap-4">
            <div className="min-w-0">
              <div className="font-medium truncate">
                {rec.estimate_number ?? rec.number ?? `Estimate #${rec.id}`}
              </div>
              <div className="text-xs text-muted-foreground truncate">
                {rec.title ?? rec.description ?? ""}
              </div>
            </div>
            <div className="text-right text-xs text-muted-foreground">
              <div className="font-medium text-foreground">{rec.status ?? "—"}</div>
              <div>{rec.created_at ? new Date(rec.created_at).toLocaleString() : ""}</div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}

export function EstimateList() {
  return (
    <ListBase resource="estimates" perPage={25}>
      <div className="p-4">
        <h2 className="text-lg font-semibold">Estimates</h2>
        <p className="text-sm text-muted-foreground">All estimates in your organization.</p>
      </div>
      <Rows />
    </ListBase>
  );
}
